/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { ZKVote, ZKVoteInterface } from "../ZKVote";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_verifier",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "clubId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "message",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "proposalId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "externalNullifier",
        type: "uint256",
      },
    ],
    name: "CastVote",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "clubId",
        type: "uint256",
      },
    ],
    name: "CreateClub",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "clubId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "bytes32",
        name: "message",
        type: "bytes32",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "externalNullifier",
        type: "uint256",
      },
    ],
    name: "CreateProposal",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "groupId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "depth",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "zeroValue",
        type: "uint256",
      },
    ],
    name: "GroupCreated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "groupId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "identityCommitment",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "root",
        type: "uint256",
      },
    ],
    name: "MemberAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "groupId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "identityCommitment",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "root",
        type: "uint256",
      },
    ],
    name: "MemberRemoved",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "nullifierHash",
        type: "uint256",
      },
    ],
    name: "NullifierHashAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "identityCommitment",
        type: "uint256",
      },
    ],
    name: "Register",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_signal",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_nullifierHash",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_root",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_externalNullifier",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_clubId",
        type: "uint256",
      },
      {
        internalType: "enum ZKVote.MessageType",
        name: "_messageType",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_flexField",
        type: "uint256",
      },
      {
        internalType: "uint256[8]",
        name: "_proof",
        type: "uint256[8]",
      },
    ],
    name: "broadcastMessage",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "clubCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "clubs",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "createClub",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "groupId",
        type: "uint256",
      },
    ],
    name: "getDepth",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "groupId",
        type: "uint256",
      },
    ],
    name: "getNumberOfLeaves",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "groupId",
        type: "uint256",
      },
    ],
    name: "getRoot",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_identityCommitment",
        type: "uint256",
      },
    ],
    name: "registerIdentity",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "registrations",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "verifier",
    outputs: [
      {
        internalType: "contract IVerifier",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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__$4c0484323457fe1a856f46a4759b553fe4$__9063b4bdd1179060640160006040518083038186803b15801561095557600080fd5b505af4158015610969573d6000803e3d6000fd5b50506040805160ff86168152602081018590528693507fc3082aa494e9088c2c9f0fb62a0b6bd46e6699acb94cfba35be29b95a93f68c89250015b60405180910390a2505050565b6109bd6103e843611000565b8114610a0b5760405162461bcd60e51b815260206004820152601660248201527f5a4b566f74653a204f7574736964652077696e646f77000000000000000000006044820152606401610244565b50565b6259455360e81b811480610a265750614e4f60f01b81145b80610a3a57506620a129aa20a4a760c91b81145b610a0b5760405162461bcd60e51b81526020600482015260146024820152735a4b566f74653a20496e76616c696420766f746560601b6044820152606401610244565b60008481526020819052604090205460ff1615610b025760405162461bcd60e51b815260206004820152603660248201527f53656d6170686f7265436f72653a20796f752063616e6e6f742075736520746860448201527f652073616d65206e756c6c6966696572207477696365000000000000000000006064820152608401610244565b6000610b0d87610dad565b9050816001600160a01b0316635fe8c13b604051806040016040528086600060088110610b3c57610b3c611022565b6020020135815260200186600160088110610b5957610b59611022565b6020020135905260408051608081018252878201359181019182529081906060820189600360200201358152508152602001604051806040016040528089600460088110610ba957610ba9611022565b6020020135815260200189600560088110610bc657610bc6611022565b60200201359052905260408051808201909152808860066020020135815260200188600760088110610bfa57610bfa611022565b602002013581525060405180608001604052808c81526020018b81526020018781526020018a8152506040518563ffffffff1660e01b8152600401610c429493929190611061565b60006040518083038186803b158015610c5a57600080fd5b505afa158015610c6e573d6000803e3d6000fd5b5050505050505050505050565b60008281526001602052604090205460ff16610ce75760405162461bcd60e51b815260206004820152602560248201527f53656d6170686f726547726f7570733a2067726f757020646f6573206e6f7420604482015264195e1a5cdd60da1b6064820152608401610244565b600082815260016020526040908190209051630b4381fd60e11b815260048101919091526024810182905273__$4c0484323457fe1a856f46a4759b553fe4$__9063168703fa9060440160006040518083038186803b158015610d4957600080fd5b505af4158015610d5d573d6000803e3d6000fd5b505050600083815260016020818152604092839020909101548251858152918201819052925084917f03fd27265b7dd1f55558bedc22a58fa3b10afb1be776e614bd5a7ba7b949940691016109a4565b6000600882604051602001610dc491815260200190565b60408051601f198184030181529190528051602090910120901c92915050565b6001600160a01b0381168114610a0b57600080fd5b60008060408385031215610e0c57600080fd5b8235610e1781610de4565b946020939093013593505050565b600060208284031215610e3757600080fd5b8135610e4281610de4565b9392505050565b6000806000806000806000806000610200808b8d031215610e6957600080fd5b8a35995060208b0135610e7b81610de4565b985060408b0135975060608b0135965060808b0135955060a08b0135945060c08b013560028110610eab57600080fd5b935060e08b01359250808b018c1015610ec357600080fd5b506101008a0190509295985092959850929598565b600060208284031215610eea57600080fd5b5035919050565b600080600060608486031215610f0657600080fd5b8335610f1181610de4565b95602085013595506040909401359392505050565b600060208284031215610f3857600080fd5b81518015158114610e4257600080fd5b634e487b7160e01b600052601160045260246000fd5b6000600019821415610f7257610f72610f48565b5060010190565b634e487b7160e01b600052602160045260246000fd5b838152600060028410610fb257634e487b7160e01b600052602160045260246000fd5b5060f89290921b60208301526021820152604101919050565b60008219821115610fde57610fde610f48565b500190565b600060208284031215610ff557600080fd5b8151610e4281610de4565b60008261101d57634e487b7160e01b600052601260045260246000fd5b500490565b634e487b7160e01b600052603260045260246000fd5b8060005b600281101561105b57815184526020938401939091019060010161103c565b50505050565b61018081016110708287611038565b60408083018660005b600280821061108857506110c3565b82518460005b838110156110ac57825182526020928301929091019060010161108e565b505050928401925060209190910190600101611079565b505050506110d460c0830185611038565b61010082018360005b60048110156110fc5781518352602092830192909101906001016110dd565b5050509594505050505056fea26469706673582212204012f666fbdc8bdb91c30d960eeb6b0012d5f4635c3767e435c67a6e6ac6b96d64736f6c634300080a0033";

type ZKVoteConstructorParams =
  | [linkLibraryAddresses: ZKVoteLibraryAddresses, signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: ZKVoteConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => {
  return (
    typeof xs[0] === "string" ||
    (Array.isArray as (arg: any) => arg is readonly any[])(xs[0]) ||
    "_isInterface" in xs[0]
  );
};

export class ZKVote__factory extends ContractFactory {
  constructor(...args: ZKVoteConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      const [linkLibraryAddresses, signer] = args;
      super(_abi, ZKVote__factory.linkBytecode(linkLibraryAddresses), signer);
    }
    this.contractName = "ZKVote";
  }

  static linkBytecode(linkLibraryAddresses: ZKVoteLibraryAddresses): string {
    let linkedBytecode = _bytecode;

    linkedBytecode = linkedBytecode.replace(
      new RegExp("__\\$4c0484323457fe1a856f46a4759b553fe4\\$__", "g"),
      linkLibraryAddresses[
        "@zk-kit/incremental-merkle-tree.sol/contracts/IncrementalBinaryTree.sol:IncrementalBinaryTree"
      ]
        .replace(/^0x/, "")
        .toLowerCase()
    );

    return linkedBytecode;
  }

  deploy(
    _verifier: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<ZKVote> {
    return super.deploy(_verifier, overrides || {}) as Promise<ZKVote>;
  }
  getDeployTransaction(
    _verifier: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_verifier, overrides || {});
  }
  attach(address: string): ZKVote {
    return super.attach(address) as ZKVote;
  }
  connect(signer: Signer): ZKVote__factory {
    return super.connect(signer) as ZKVote__factory;
  }
  static readonly contractName: "ZKVote";
  public readonly contractName: "ZKVote";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ZKVoteInterface {
    return new utils.Interface(_abi) as ZKVoteInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): ZKVote {
    return new Contract(address, _abi, signerOrProvider) as ZKVote;
  }
}

export interface ZKVoteLibraryAddresses {
  ["@zk-kit/incremental-merkle-tree.sol/contracts/IncrementalBinaryTree.sol:IncrementalBinaryTree"]: string;
}
